import {
  Box,
  Stack,
  Typography,
  useTheme,
  Divider,
  styled,
} from "@mui/material";
import React, { useState } from "react";
import StarIcon from "../../icons/StarIcon";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import PropertysData from "../../../_moc_data/PropertysData";
import PossibilitiesItem from "../../Property/CarouselItem/PossibilitiesItem";
import useWindowSize from "../../../hooks/useWindowSize";
import Iconify from "../../iconify/iconify";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { LayoutContainer } from "../../app-layoout/container";
import { ThreeViewCarousel } from "../../../hooks/CarouselView";
import { useDataListProperties } from "../../../hooks/use-data-list-properties";
import { formatMoney } from "../../../lib/formatMoney";
import { useDataListPropertiesOutstanding } from "../../../hooks/use-data-list-properties-outstanding";

export const StyledPrevNextBox = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  background: theme.palette.background.main,
  border: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  userSelect: "none",
}));
const Carousel = () => {
  const theme = useTheme();
  const screenWidth = useWindowSize();
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiper, setSwiper] = useState(null);
  const { dataListPropertiesOutstandingQuery } =
    useDataListPropertiesOutstanding();

  const handleSlideChange = () => {
    if (swiper) {
      setActiveIndex(swiper.realIndex);
    }
  };

  const handleSwiperInit = (swiper) => {
    setSwiper(swiper);
  };

  const handlePrevButton = () => {
    if (swiper) {
      swiper.slidePrev();
    }
  };

  const handleNextButton = () => {
    if (swiper) {
      swiper.slideNext();
    }
  };
  if (!dataListPropertiesOutstandingQuery.data) return <></>;
  return (
    <Stack py={{ xs: 2, md: 8 }} bgcolor={theme.palette.background.default}>
      <LayoutContainer>
        <Stack mb={3}>
          <Box mb={2}>
            <StarIcon />
          </Box>
          <Typography variant="h3" color="text.secondary">
            Propiedades Destacadas
          </Typography>
          <Typography variant="subtitle1" color="text.primary">
            Explora nuestra selección cuidadosamente curada de propiedades
            destacadas. Cada listado ofrece una visión de hogares e inversiones
            excepcionales disponibles a través de Plusval State. Haz clic en
            "Ver detalles de la propiedad" para obtener más información.
          </Typography>
        </Stack>

        <Swiper
          grabCursor={true}
          centeredSlides={false}
          slidesPerView={ThreeViewCarousel(screenWidth)}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 2,
            slideShadows: false,
          }}
          loop={true}
          className="mySwiper"
          modules={[Navigation, EffectCoverflow]}
          onSlideChange={handleSlideChange}
          onSwiper={handleSwiperInit}
          navigation={false}
        >
          {dataListPropertiesOutstandingQuery.data.data
            .map((items) => {
              let saleStage = [];
              if (!!items.IDO) {
                saleStage = items.IDO.iDOSaleStage;
              }

              if (!!items.Token) {
                saleStage = items.Token.tokenSaleStage;
              }
              return {
                id: items.id || "",
                slug: items?.slug || "",
                img: items.cardImageUrl || "/assets/about/plusvalica.png",
                name: items.name || "",
                description: items?.description?.descripcion || "",
                isNormal: items.isNormal,
                isTokenize: items.isTokenize,
                isIDO: items.isIDO,
                price: formatMoney({
                  amount: Number(items?.price || "0"),
                  symbol: " MXN",
                }),
                saleStage,
              };
            })
            .map((item, i) => (
              <SwiperSlide key={i}>
                <PossibilitiesItem {...item} />
              </SwiperSlide>
            ))}
        </Swiper>
        <Stack pt={{ xs: 2, md: 5 }}>
          <Divider variant="fullWidth" orientation="horizontal" />
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            py={2}
          >
            <Typography variant="subtitle1" color="text.primary">
              {activeIndex + 1 < 10 ? 0 : null}
              {activeIndex + 1} de {PropertysData.length}
            </Typography>

            <Stack direction="row" gap={2}>
              <StyledPrevNextBox onClick={handlePrevButton}>
                <Iconify icon="grommet-icons:link-previous" />
              </StyledPrevNextBox>
              <StyledPrevNextBox onClick={handleNextButton}>
                <Iconify icon="grommet-icons:link-next" />
              </StyledPrevNextBox>
            </Stack>
          </Stack>
        </Stack>
      </LayoutContainer>
    </Stack>
  );
};

export default Carousel;
